<div class="spinner" *ngIf="isLoading; else showLoginModal"></div>
<ng-template #showLoginModal>
  <div class="login-modal-wrapper">
    <h2>{{ modalData?.social_heading }}</h2>
    <!-- Social login buttons -->
    <app-social-login-buttons
      [loginModal]="true"
      [updateExistingAccountData]="updateExistingAccountData"
    ></app-social-login-buttons>
    <h2>{{ modalData?.email_heading }}</h2>
    <!-- Login form -->
    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="submit()">
      <!-- Unverified email error -->
      <div *ngIf="unverified">
        <div class="form-errors">
          <p class="form-error">
            <ng-container
              *ngIf="!verificationResent; else verificationResentText"
            >
              <span> Your address is not verified. </span>
              <a (click)="resendVerification()"
                >Click here to resend verification email</a
              >
            </ng-container>
            <ng-template #verificationResentText>
              Email resent. Please check your inbox
            </ng-template>
          </p>
        </div>
      </div>
      <!-- Account locked error -->
      <div *ngIf="accountLocked">
        <div class="form-errors">
          <p class="form-error">
            <span>{{ modalData.account_locked }}</span>
          </p>
        </div>
      </div>
      <!-- Login not found error -->
      <div class="form-errors" *ngIf="loginNotFound && !accountLocked">
        <p class="form-error">
          <span>{{ modalData.login_incorrect }}</span>
        </p>
      </div>
      <!-- Other errors  -->
      <div class="form-errors" *ngIf="otherError">
        <p class="form-error">{{ otherErrorMessage }}</p>
      </div>
      <!-- Update user error -->
      <div class="form-errors" *ngIf="userUpdateError">
        <p class="form-error">{{ userUpdateErrorMessage }}</p>
      </div>

      <!-- Form validation errors -->
      <div
        class="form-errors"
        *ngIf="
          submitted &&
          (formControl['email'].errors || formControl['password'].errors)
        "
      >
        <!-- Required error -->
        <p
          class="form-error"
          *ngIf="
            formControl['email'].errors &&
            formControl['email'].errors['required']
          "
        >
          {{ modalData.email_address_empty_error }}
        </p>

        <!-- Invalid email error -->
        <p
          class="form-error"
          *ngIf="
            formControl['email'].errors && formControl['email'].errors['email']
          "
        >
          {{ modalData.email_address_invalid_error }}
        </p>

        <!-- No password validation error -->
        <p
          class="form-error"
          *ngIf="
            formControl['password'].errors &&
            formControl['password'].errors['required']
          "
        >
          {{ modalData.password_empty_error }}
        </p>
      </div>

      <!-- Input fields -->
      <div class="login-fields">
        <div class="form-field">
          <input
            type="email"
            id="email"
            class="email"
            formControlName="email"
            placeholder="Email Address"
          />
        </div>
        <div class="form-field">
          <input
            type="password"
            id="password"
            class="password"
            formControlName="password"
            placeholder="Password"
          />
        </div>
      </div>

      <a [routerLink]="'/forgotten-password'" class="fgpw"
        >Forgotten password</a
      >
      <button class="button" [class.button-loading]="loggingIn" type="submit">
        <span>Login</span>
      </button>
    </form>
  </div>
</ng-template>
